import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useToken from '../Account/Components/useSession';
import Login from '../Account/Login';
import '../../App.css';
import '../../styles/newThread.css';
import {
  Navigate,
  useParams
} from "react-router-dom";
import ImageTools from '../Images/ImageTools';

export default function NewPost({ sessionData, setSessionData }) {
    let [title, setTitle] = useState();
    let [desc, setDesc] = useState();
    let [success, setSuccess] = useState();
    let [forbidden, setForbidden] = useState();
    let [unauth, setUnauth] = useState();
    let [tooLarge, setTooLarge] = useState();
    let [file, setFile] = useState();
    let [locked, setLocked] = useState(true);
    let [notif, setNotif] = useState(true);
    let [topic, setTopic] = useState(1);


    const { topicID } = useParams();

    let err = "No Error";

    const handleSubmit = async e => {
        e.preventDefault();
        if(title && desc) {
            const formData = new FormData();
            if(file) {
                formData.append('image', file);
                console.log("attached image");
            }
            formData.append('title', title);
            formData.append('desc', desc);
            formData.append('username', sessionData?.user?.username);
            formData.append('SID', sessionData?.token);
            formData.append('topic', topicID ? topicID : topic); //If topicID (param) exists, send that, else send topic from dropdown menu
            formData.append('locked', locked == true ? 0 : 1); //The locked var here, true =  allow replies. Reverse value. Should have named it better
            formData.append('notif', notif ? 1 : 0);
            console.log("Creating Thread" + title + desc);
            let url = "https://api.board.dylang140.com/newThread";
            let c = await fetch(url, {
                method: 'POST',
                body: formData
              });
            if(c.ok) {
                setSuccess(true);
            }
            else if(c.status === 403) { //Forbidden
                setForbidden(true);
            }
            else if(c.status === 401) { //Unauthorized 
                setUnauth(true);
            }
        }
    }

     let uploadFile = async (e) => {
        //console.log(e);
        if(e.size >= 1000000) {
          setTooLarge(true);
          console.log("resizing");
          let newFile = await ImageTools.resizeFile(e); //Resize image if too large
          //console.log(newFile);
          setFile(ImageTools.dataURItoBlob(newFile));
          setTooLarge(false);
        }
        else {
          console.log("all good");
          setFile(e);
        }
      };

    if(forbidden) {
        return <Navigate replace to="/forbidden" />
    }
    else if(unauth) {
        return <Navigate replace to="/logout" />
    }
    else if(success) {
        return <Navigate replace to="/" />  
    }
    else if(sessionData?.token){
        let topicSelect;
        if(!topicID){ //If posting a topic from within a topic folder on client side, don't need to select topic. Otherwise, display dropdown of topics
            topicSelect = ( //TODO: Fetch list of topics and display those, rather than static list
                <div>
                    <label for="cars">Choose a topic: </label>
                    <select id="topic" name="topic"
                        value={topic}
                        onChange={e => setTopic(e.target.value)}
                    >
                        <option value="1">General</option>
                        <option value="3">Food</option>
                        <option value="5">School</option>
                        <option value="6">Photos</option>
                        <option value="7">TV, Movies, Music</option>
                        <option value="9">Jonathan's Room</option>
                    </select>
                </div>
            );
        }
        return(
            <div className="Page newThread">
            <h1>New Post</h1>
            <form onSubmit={handleSubmit}>
                <label>
                    <p>Post Title</p>
                    <input type="text" className="TextField" maxLength="35" onChange={e => setTitle(e.target.value)} value={title} />
                    <br/>{title ? title.length + "/35" : ""}
                </label>
                <br/>
                <input type="checkbox" id="lock" name="lock" checked={locked ? "checked" : ""} onChange={e => setLocked(!locked)} />
                <label htmlFor="lock"> Allow other users to reply?</label><br/>
                <input type="checkbox" id="notif" name="notif" checked={notif ? "checked" : ""} onChange={e => setNotif(!notif)} />
                <label htmlFor="notif"> Email notifications for new replies?</label><br/>
                <br/>
                {topicSelect}
                <label>
                    <p>Description</p>
                    <textarea type="text" className="TextField" maxLength="10000" onChange={e => setDesc(e.target.value)} value={desc} rows="10" cols="50"/>
                    <br/>{desc ? desc.length + "/10,000" : ""}
                </label>
                <br/>
                <img width="400" src={file ? URL.createObjectURL(file) : ""} />
                <br/>
                    <input type="file" name="file" onChange={e => uploadFile(e.target.files[0])}/>
                <br/>
                <div>
                    <br/>
                    <button className="Button" type="submit">Submit</button>
                </div>
            </form>
            </div>
        )
    }
    else {
        return <Login sessionData={sessionData} setSessionData={setSessionData} />;
    }
}

Login.propTypes = {
    setSessionData: PropTypes.func.isRequired,
};